module.exports = __webpack_public_path__ + "img/foot_logo.7f6e9ab7.webp";